<template>
    <div>
        ...
    </div>
</template>

<script>
export default {
    name: "module",
    data() {
        return {}
    },
    created() {

    },
    computed: {},
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.modules"), []);
    },
    methods: {}
}
</script>

<style scoped>

</style>